import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e361def0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "action-btns" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon-f icon-back fs-10" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args))),
      type: "button"
    }, [
      _hoisted_2,
      _createElementVNode("span", null, _toDisplayString(_ctx.firstBtnText || _ctx.defaultBackText), 1)
    ]),
    _createElementVNode("button", {
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args))),
      type: "button"
    }, _toDisplayString(_ctx.secondBtnText || _ctx.defaultCancelText), 1)
  ]))
}